<template>
  <div>
    <div id="pic" v-if="render === ''">
      <div class="top">
        <!--        <div class="meng"></div>-->
        <!--        <img src="./lsp/Pro-tou1.png" alt="" class="topTou1" />-->
        <!--        <img src="./lsp/Pro-tou2.png" alt="" class="topTou2" />-->
        <img class="img" src="../assets/iap.png" />
        <div crossorigin="anonymous" class="background" :style="`background-image:url('${pro.img}')`" />
      </div>
      <div class="bottom">
        <!-- <img src="./lsp/yinying.png" style="position: absolute;left: -20px;top: -20px;" /> -->
        <img src="./lsp/yinhao-standard.png" class="shangyin" />
        <div class="direction" :style="{ fontSize: dirFont + 'px' }">{{ pro.direction }}</div>
        <div :style="{ fontSize: dirFont + 'px' }" id="direction" class="direction"
          style="max-width: 750px;visibility: hidden;position: absolute">{{ pro.direction }}</div>
        <div class="heng" :style="{ top: linesOfDer * 30 + 100 + 'px' }"></div>
        <img class="tou" crossorigin="anonymous" :src="pro.professor.avatar" />
        <div class="teacher">
          PROF.
          <br />
          <div :style="{ fontSize: fontSize + 'px' }" style="font-family: inherit;display: inline-block;width: 250px">
            {{ pro.professor.lastName.toUpperCase() }}
          </div>
          <div :style="{ fontSize: fontSize + 'px' }" id="mirror"
            style="position: absolute;visibility: hidden;font-family: inherit">
            {{ pro.professor.lastName.toUpperCase() }}
          </div>
        </div>
        <div class="school">
          <div :style="{ fontSize: schoolFont + 'px' }" style="display: inline-block">
            {{ pro.professor.school }}
          </div>
          <div :style="{ fontSize: schoolFont + 'px' }" id="school" style="visibility: hidden;position: absolute">
            {{ pro.professor.school }}
          </div>
          <br />
          {{ pro.professor.position }}
        </div>
        <div id="qrcode" />
        <img class="psimg" src="./lsp/ps.png" />
        <img src="./lsp/yinhao-standard.png" class="xiayin" />
      </div>
    </div>
    <img :src="render" v-else style="width:100%" />
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'

export default {
  name: 'litepage',
  data() {
    return {
      uuid: '',
      name: 'Green',
      school: '',
      position: '',
      total: 0,
      num: 0,
      OSS: process.env.VUE_APP_OSS,
      direction: '',
      render: '',
      file: '',
      tou: '',
      img: '', // 海报背景图地址
      linesOfDer: 1,
      firstName: '',
      professor: '',
      tags: '',
      fontSize: 36,
      schoolFont: 28,
      dirFont: 28,
      pro: {}
    }
  },
  mounted() {
    Object.assign(this.$data, this.pro)
    let res = [this.pro.subject.content]
    for (let i of this.tags) {
      res.push(i.content)
    }
    this.tags = res
    // console.log(res)
    this.set()
    this.$nextTick(() => {
      this.initFontSize()
    })

    setTimeout(() => {
      this.exportx()
    }, 0)
    // this.set()
    // this.exportx()
  },
  methods: {
    initDover() {
      let d = this.tags
      if (d.length >= 4) {
        this.linesOfDer = 2
        let len = []
        let max = 0
        for (let i of d) {
          max += i.length
          len.push(max)
        }
        let mid = Math.floor(max / 2)
        let key
        for (let i = 0; i < d.length; i++) {
          if (len[i] >= mid) {
            let a = Math.abs((max - len[i] + (d.length - i - 2)) - (len[i] + i))
            let b = Math.abs((max - len[i + 1] + (d.length - i - 3)) - (len[i] + i + 1))
            if (a >= b) {
              key = i + 1
            } else {
              key = i
            }
            break
          }
        }
        let res = ''
        for (let i = 0; i < d.length; i++) {
          res += d[i] + (i === key || i === d.length - 1 ? '\n' : ' | ')
        }
        this.direction = res
        // this.direction = x[0] + ' | ' + x[1] + '\n' + x[2] + ' | ' + x[3]
      } else {
        this.linesOfDer = 1
        let res = ''
        for (let i = 0; i < d.length; i++) {
          res += d[i] + (i === d.length - 1 ? '\n' : ' | ')
        }
        this.direction = res
      }
    },
    initFontSize() {
      let key, key2, key3
      let _this = this
      async function test() {
        for (let i = 0; i < 20; i++) {
          console.log(i)
          await _this.$nextTick(() => {
            key = document.getElementById('mirror').offsetWidth
            if (key > 250) {
              _this.fontSize -= 1
            }
          })
          if (key <= 250) {
            break
          }
        }
      }

      test()
      async function test2() {
        for (let i = 0; i < 20; i++) {
          await _this.$nextTick(() => {
            key2 = document.getElementById('school').offsetWidth
            if (key2 > 250) {
              _this.schoolFont -= 1
            }
          })
          if (key2 <= 250) {
            break
          }
        }
      }

      test2()
      async function test3() {
        for (let i = 0; i < 16; i++) {
          console.log((i))
          await _this.$nextTick(() => {
            key3 = document.getElementById('direction').offsetWidth
            if (key3 > 475) {
              _this.dirFont -= 1
            }
          })
          if (key3 <= 475) {
            break
          }
        }
      }

      test3()
    },
    set() {
      let origin = 'https://p.eliteqihang.com/pro/'
      let qrcode = `https://${origin}${this.pro.uuid}`
      this.linesOfDer = 1
      this.initDover()
      document.getElementById('qrcode').innerHTML = ''
      // eslint-disable-next-line
      new QRCode('qrcode', {
        text: qrcode,
        width: 100, // 图像宽度
        height: 100, // 图像高度
        colorDark: '#000000', // 前景色
        colorLight: '#ffffff', // 背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    exportx() {
      this.$nextTick(() => {
        document.body.style.width = '2024px'

        html2canvas(document.querySelector('#pic'), {
          useCORS: true,
          scrollY: 0,
          height: 1624
        }).then(canvas => {
          document.body.style.width = 'unset'
          let a = document.createElement('a')
          a.href = canvas.toDataURL('image/png', 0.9)
          a.setAttribute('target', '_blank')
          a.download = `${this.tags.join('、')}-${this.firstName} ${this.lastName}.png`
          a.click()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  font-family: PFBD;
}

#pic {
  width: 375 * 2px;
  height: 812 * 2px;
  position: relative;

  .img {
    width: 375 * 2px;
    height: 392 * 2px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }

  .background {
    width: 375 * 2px;
    height: 392 * 2px;
    top: 0;
    z-index: 0;
    background-position: top;
    background-size: cover;
    position: absolute;
  }

  .meng {
    width: 375 * 2px;
    height: 392 * 2px;
    position: absolute;
    top: 0 * 2px;
    z-index: 1;
    background: rgba(#000000, 0.65);
  }

  .xian {
    width: 35 * 2px;
    left: 30 * 2px;
    border-top: 2 * 2px solid #fff;
    position: absolute;
    top: 70 * 2px;
  }

  .top {
    width: 375 * 2px;
    height: 392 * 2px;
    position: relative;

    .topTou1 {
      width: 102 * 2px;
      position: absolute;
      top: 38 * 2px;
      left: 50 * 2px;
      z-index: 2;
    }

    .topTou2 {
      width: 275 * 2px;
      position: absolute;
      top: 95 * 2px;
      left: 50 * 2px;
      z-index: 2;
    }
  }

  .bottom {
    width: 375 * 2px;
    height: 437 * 2px;
    position: relative;
    z-index: 100;

    .shangyin {
      top: 40 * 2px;
      left: 50 * 2px;
      position: absolute;
    }

    .tou {
      position: absolute;
      width: 120 * 2px;
      height: 120 * 2px;
      left: 50 * 2px;
      top: 120 * 2px;
      border-radius: 50%;
      background-color: white;
    }

    .direction {
      position: absolute;
      right: 50 * 2px;
      top: 40 * 2px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 14 * 2px;
      line-height: 18 * 2px;
      text-align: right;
      color: #d7af87;
      max-width: 475px;
      white-space: pre-line;
    }

    .heng {
      position: absolute;
      right: 50 * 2px;
      top: 80 * 2px;
      width: 25 * 2px;
      border-top: 2 * 2px solid #d7af87;
    }

    .teacher {
      position: absolute;
      left: 200 * 2px;
      top: 122 * 2px;
      width: 130 * 2px;
      font-family: LemonMilkbold;
      font-style: normal;
      font-weight: 600;
      font-size: 18 * 2px;
      line-height: 25 * 2px;
      //letter-spacing: 0.05em;
      color: #d7af87;
      text-align: left;
    }

    .school {
      position: absolute;
      left: 200 * 2px;
      top: 172 * 2px;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 600;
      font-size: 14 * 2px;
      text-align: left;
      line-height: 19.6 * 2px;
      letter-spacing: 0.05em;
      color: #555555;

      div {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 14 * 2px;
        line-height: 19.6 * 2px;
        letter-spacing: 0.05em;
        color: #555555;
      }
    }

    #qrcode {
      position: absolute;
      right: 45 * 2px;
      bottom: 40 * 2px;
    }

    .ps {
      position: absolute;
      left: 90 * 2px;
      bottom: 45 * 2px;
      font-family: PFBD;
      font-style: normal;
      font-weight: 600;
      font-size: 8 * 2px;
      display: flex;
      align-items: center;
      color: #555555;
    }

    .psimg {
      position: absolute;
      left: 50 * 2px;
      bottom: 40 * 2px;
      width: 213 * 2px;
    }

    .xiayin {
      position: absolute;
      right: 50 * 2px;
      bottom: 134 * 2px;
      transform: rotate(-180deg);
    }
  }
}
</style>
